import React, { ReactElement } from 'react';
import { Route, Switch } from 'react-router-dom';
import { ParentPaths } from 'src/components/AppRoutes/Parent/ParentPaths';
import { ParentCorpCreatePage } from 'src/components/enterprise/features/Corporate/ParentCorpCreatePage/ParentCorpCreatePage';
import withEnterpriseLayout from 'src/components/AppRoutes/Enterprise/withEnterpriseLayout';
import { ParentCorpEditPage } from 'src/components/enterprise/features/Corporate/ParentCorpEditPage/ParentCorpEditPage';
import { ChildCorpEditPage } from 'src/components/enterprise/features/Corporate/ChildCorpEditPage/ChildCorpEditPage';

export const ParentRoutes = (): JSX.Element => {
  const ParentCreatePageLayout = withEnterpriseLayout(ParentCorpCreatePage);
  const ParentEditPageLayout = withEnterpriseLayout(ParentCorpEditPage);
  const CorporateEditPageLayout = withEnterpriseLayout(ChildCorpEditPage);

  return (
    <Switch>
      <Route
        exact
        path={ParentPaths.create}
        component={(): ReactElement => (
          <ParentCreatePageLayout pageTitle="Create new parent account" />
        )}
      />
      <Route
        exact
        path={ParentPaths.edit}
        component={(): ReactElement => (
          <ParentEditPageLayout pageTitle="Edit Parent Account" />
        )}
      />
      <Route
        exact
        path={ParentPaths.editChild}
        component={(): ReactElement => (
          <CorporateEditPageLayout pageTitle="Edit Child Account" />
        )}
      />
    </Switch>
  );
};
